module.exports = __webpack_public_path__ + "img/medal-challenge.e0daf008.png";